module.exports = __webpack_public_path__ + "static/media/default-logo-raq.2f39691f.svg";